/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Type_Waiting_StatusesInputs */

const en_task_catalog_type_waiting_statuses = /** @type {(inputs: Task_Catalog_Type_Waiting_StatusesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting reasons`)
};

const pt_br2_task_catalog_type_waiting_statuses = /** @type {(inputs: Task_Catalog_Type_Waiting_StatusesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivos de espera`)
};

/**
* | output |
* | --- |
* | "Waiting reasons" |
*
* @param {Task_Catalog_Type_Waiting_StatusesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_type_waiting_statuses = /** @type {((inputs?: Task_Catalog_Type_Waiting_StatusesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Type_Waiting_StatusesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_type_waiting_statuses(inputs)
	return pt_br2_task_catalog_type_waiting_statuses(inputs)
});